/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateUserTypeMutationRequest,
  UpdateUserTypeMutationResponse,
  UpdateUserTypePathParams,
  UpdateUserType400,
} from '../types/UpdateUserType'

function getUpdateUserTypeUrl({
  user_id,
}: {
  user_id: UpdateUserTypePathParams['user_id']
}) {
  const res = {
    method: 'PUT',
    url: `/api/v1/users/${user_id}/user-type/` as const,
  }
  return res
}

/**
 * @description API endpoint for changing a user's type.
 * Architecture: WRITE operation - uses use case pattern.
 * Only Admin users can access this endpoint.
 * @summary Change a user's type
 * {@link /api/v1/users/:user_id/user-type/}
 */
export async function updateUserType(
  { user_id }: { user_id: UpdateUserTypePathParams['user_id'] },
  data: UpdateUserTypeMutationRequest,
  config: Partial<RequestConfig<UpdateUserTypeMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateUserTypeMutationResponse,
    ResponseErrorConfig<UpdateUserType400>,
    UpdateUserTypeMutationRequest
  >({
    method: 'PUT',
    url: getUpdateUserTypeUrl({ user_id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
